/* tslint:disable */

/**
 * HR Portal API
 * HR Portal API
 *
 * The version of the OpenAPI document: 0.1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 *
 * @export
 * @interface BaseRequest
 */
export interface BaseRequest {
    /**
     *
     * @type {string}
     * @memberof BaseRequest
     */
    requestId: string;
    /**
     *
     * @type {string}
     * @memberof BaseRequest
     */
    timestamp: string;
    /**
     *
     * @type {string}
     * @memberof BaseRequest
     */
    issueId: string;
}

export function BaseRequestFromJSON(json: any): BaseRequest {
    return BaseRequestFromJSONTyped(json, false);
}

export function BaseRequestFromJSONTyped(json: any, _: boolean): BaseRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {

        'requestId': json['request_id'],
        'timestamp': json['timestamp'],
        'issueId': json['issue_id'],
    };
}

export function BaseRequestToJSON(value?: BaseRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {

        'request_id': value.requestId,
        'timestamp': value.timestamp,
        'issue_id': value.issueId,
    };
}
